import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const SalesDashboardContext = createContext(defaultState);

export default SalesDashboardContext;
